<template>
	<div style="width: 100%;background: #fff;">
		<div class="d-flex p-2" style="align-items: center;">
			<div style="font-size: 14px;" class="mr-2">截至日期</div>
			<el-date-picker v-model="value1" type="date" placeholder="选择日期" class="mr-2" size="mini"></el-date-picker>
			<el-button type="primary" size="mini">查询</el-button>
		</div>
		<div style="width: 100%;justify-content: center;align-items: center;flex-flow: column;" class="d-flex mt-1">
			<div>净资产</div>
			<div style="font-weight: 800;font-size: 24px;">360045.02</div>
		</div>
		<div class="d-flex">
			<div style="width: 48%;margin-right: 2%;">
				<div class="csss">
					<el-table :data="kon" style="width: 100%" size="mini">
						<template slot="empty">
						    <div></div>
						</template>
						<el-table-column  prop="name" label="资产"></el-table-column>
						<el-table-column  prop="address" label="期末余额" align="right" ></el-table-column>
					</el-table>
				</div>
				<el-table :data="tableData" style="width: 100%" size="mini" show-summary sum-text="流动资金合计">
					<el-table-column  prop="name" label="流动资产"></el-table-column>
					<el-table-column  prop="address" align="right" ></el-table-column>
				</el-table>
				<el-table :data="tableDatb" style="width: 100%" size="mini" show-summary sum-text="非流动资金合计">
					<el-table-column  prop="name" label="非流动资产"></el-table-column>
					<el-table-column  prop="address" align="right" ></el-table-column>
				</el-table>
			</div>
			<div style="width: 48%;margin-left: 2%;">
				<div class="csss">
					<el-table :data="kon" style="width: 100%" size="mini">
						<template slot="empty">
						    <div></div>
						</template>
						<el-table-column  prop="name" label="负债和所有者权益"></el-table-column>
						<el-table-column  prop="address" label="期末余额" align="right" ></el-table-column>
					</el-table>
				</div>
				<el-table :data="tableDatc" style="width: 100%" size="mini" show-summary sum-text="负债合计">
					<el-table-column  prop="name" label="负债"></el-table-column>
					<el-table-column  prop="address" label="" align="right" ></el-table-column>
				</el-table>
				<el-table :data="tableDatd" style="width: 100%" size="mini" show-summary sum-text="所有者权益合计">
					<el-table-column  prop="name" label="所有者权益"></el-table-column>
					<el-table-column  prop="address" label="" align="right" ></el-table-column>
				</el-table>
			</div>
		</div>
	</div>
</template>

<script>
import buttonSearch from '@/components/common/button-search.vue'; // 引入 按钮、搜索、高级搜索组件
import common from '@/common/mixins/common.js'; // 引入 全局共公样式
import { mapState } from 'vuex'; // 引入 全局 公共数据
export default {
	mixins: [common], // 引入mixins里的common.js
	inject: ['layout'], // 依赖注入
	// 引入注册
	components: {
		buttonSearch
	},
	data() {
		return {
			kon:'',
			value1: '',
			tableData: [
				{
					name: '默认账户',
					address: '0'
				},
				{
					name: '现金',
					address: '355215.02'
				},
				{
					name: '银行【对公】',
					address: '355215.02'
				},
				{
					name: '支付宝',
					address: '355215.02'
				},
				{
					name: '微信',
					address: '355215.02'
				},
				{
					name: '固定资产',
					address: '355214'
				}
			],
			tableDatb:[
				{
					name: '应收款',
					address: '1000'
				},
				{
					name: '预付款',
					address: '1872'
				},
				{
					name:'库存商品',
					address:'156'
				}
			],
			tableDatc:[
				{
					name: '应付款',
					address: '1000'
				},
				{
					name: '预收款',
					address: '1872'
				}
			],
			tableDatd:[
				{
					name: '实收资本',
					address: '1000'
				},
				{
					name: '未分配利润',
					address: '1872'
				}
			]
		};
	},

	methods: {},
};
</script>

<style>
	.csss .el-table__empty-block{
		min-height: 0px;
	}
</style>
